import React, { useState, useEffect } from 'react';
import { homeApi } from '../../utils/api';
import { getImageUrl } from '../../config/imageConfig';
import './CarouselBanner.css';

function CarouselBanner({ categoryNameEn, defaultImage, defaultTitle, defaultSubtitle, defaultLinkUrl, defaultLinkText, className = '' }) {
  const [carouselSlides, setCarouselSlides] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  // const [loading, setLoading] = useState(true); // 暂时不需要loading状态显示
  // const [error, setError] = useState(null); // 暂时不需要error状态显示

  // 重置currentSlide当轮播图数据改变时
  useEffect(() => {
    if (carouselSlides.length > 0) {
      setCurrentSlide(0);
    }
  }, [carouselSlides.length]);

  // 获取轮播图数据
  useEffect(() => {
    const fetchCarouselData = async () => {
      try {
        const response = await homeApi.getCarousel(categoryNameEn);
        
        // 检查响应数据结构 - 根据API返回格式处理
        let slides = [];
        if (response && response.data && Array.isArray(response.data)) {
          // 标准API响应格式: {code, message, data}
          slides = response.data.filter(slide => slide.isActive === true);
        } else if (response && Array.isArray(response)) {
          // 直接数组格式
          slides = response.filter(slide => slide.isActive === true);
        }
        
        // 按sortOrder排序
        slides.sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
        setCarouselSlides(slides);
      } catch (err) {
        console.error('获取轮播图数据失败:', err);
        setCarouselSlides([]);
      }
    };

    if (categoryNameEn) {
      fetchCarouselData();
    }
  }, [categoryNameEn]);

  // 轮播图自动切换
  useEffect(() => {
    if (carouselSlides.length > 1) {
      const currentSlideData = carouselSlides[currentSlide];
      const duration = currentSlideData?.displayDuration || 5000;
      
      const timer = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % carouselSlides.length);
      }, duration);
      return () => clearInterval(timer);
    }
  }, [carouselSlides, currentSlide]);

  // 如果有轮播图数据，显示动态轮播图
  if (carouselSlides.length > 0) {
    const currentSlideData = carouselSlides[currentSlide];

    return (
      <section 
        className={`carousel-banner ${className}`}
        style={{ backgroundImage: `url(${getImageUrl(currentSlideData.imageUrl)})` }}
      >
        {/* 轮播图指示器 */}
        {carouselSlides.length > 1 && (
          <div className="carousel-indicators">
            {carouselSlides.map((_, index) => (
              <button
                key={index}
                className={`indicator ${index === currentSlide ? 'active' : ''}`}
                onClick={() => setCurrentSlide(index)}
              />
            ))}
          </div>
        )}
      </section>
    );
  }

  // 如果没有轮播图数据，显示默认hero section
  return (
    <section 
      className={`carousel-banner default-banner ${className}`}
      style={{ backgroundImage: `url(${defaultImage})` }}
    >
    </section>
  );
}

export default CarouselBanner;